import { createFileRoute } from "@tanstack/react-router";
import { loadBlockPage } from "~/utils/content-fns";
import { BlockRenderer } from "~/components/blocks";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/partners/$slug")({
  loader: async ({ params }) => {
    const page = await loadBlockPage({ data: { collection: "partners", slug: params.slug } });
    return page as any;
  },
  head: ({ loaderData }) => ({ meta: loaderData ? seo({ title: (loaderData as any).seo_title || (loaderData as any).title, description: (loaderData as any).seo_description, image: (loaderData as any).featured_image, url: `/partners/${(loaderData as any).slug}` }) : [], links: loaderData ? seoLinks({ url: `/partners/${(loaderData as any).slug}` }) : [] }),
  component: () => { const p = Route.useLoaderData() as any; return <BlockRenderer blocks={p.blocks || []} />; },
});
